// import React, { useState } from 'react';
// import { useNavigate, Link } from 'react-router-dom';
// import { db, auth } from '../firebase.js';
// import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
// import { createUserWithEmailAndPassword } from 'firebase/auth';
// import { Checkbox } from '@mui/material';

// const SignupPage = () => {
//     const navigate = useNavigate();

//     const [brandName, setBrandName] = useState('');
//     const [phoneNumber, setPhoneNumber] = useState('');
//     const [emailAddress, setEmailAddress] = useState('');
//     const [gstNumber, setGstNumber] = useState('');
//     const [address, setAddress] = useState('');
//     const [city, setCity] = useState('');
//     const [state, setState] = useState('');
//     const [pincode, setPincode] = useState('');

//     const [password, setPassword] = useState('');
//     const [confirmPassword, setConfirmPassword] = useState('');
//     const [error, setError] = useState('');
//     const [success, setSuccess] = useState('');
//     const [emailSent, setEmailSent] = useState(false);
//     const [termsAccepted, setTermsAccepted] = useState(false);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setError('');
//         setSuccess('');
//         setEmailSent(false);

//         if (password !== confirmPassword) {
//             setError('Passwords do not match.');
//             return;
//         }

//         if (!termsAccepted) {
//             setError('You must accept the terms and conditions to proceed.');
//             return;
//         }

//         try {
//             const userCredential = await createUserWithEmailAndPassword(auth, emailAddress, password);
//             const user = userCredential.user;

//             // Save user profile data
//             const userRef = doc(db, 'users', user.uid);
//             await setDoc(userRef, {
//                 brandName,
//                 phoneNumber,
//                 emailAddress,
//                 gstNumber,
//                 address,
//                 city,
//                 state,
//                 pincode,
//                 uid: user.uid,
//                 profileUpdatedAt: serverTimestamp(),
//             });

//             setSuccess('Sign up successful! Please check your email to verify your account.');

//         } catch (err) {
//             console.error('Error signing up:', err);
            
//             if (err.code === 'auth/email-already-in-use') {
//                 setError('Email already exists. Please try logging in or use a different email address.');
//             } else {
//                 setError('An error occurred. Please try again.');
//             }
//         }
//     };

//     return (
//         <div style={styles.container}>
//             <h1 style={styles.heading}>Sign up</h1>
//             <form onSubmit={handleSubmit} style={styles.form}>
//                 <label style={styles.label}>
//                     Brand Name:
//                     <input
//                         type="text"
//                         value={brandName}
//                         onChange={(e) => setBrandName(e.target.value)}
//                         required
//                         style={styles.input}
//                     />
//                 </label>
//                 <label style={styles.label}>
//                     Phone Number:
//                     <input
//                         type="tel"
//                         value={phoneNumber}
//                         onChange={(e) => setPhoneNumber(e.target.value)}
//                         required
//                         pattern="[0-9]{10}"
//                         title="Please enter a valid 10-digit phone number."
//                         style={styles.input}
//                     />
//                 </label>
//                 <label style={styles.label}>
//                     Email Address:
//                     <input
//                         type="email"
//                         value={emailAddress}
//                         onChange={(e) => setEmailAddress(e.target.value)}
//                         required
//                         style={styles.input}
//                     />
//                 </label>
//                 <label style={styles.label}>
//                     GST Number (Optional):
//                     <input
//                         type="text"
//                         value={gstNumber}
//                         onChange={(e) => setGstNumber(e.target.value)}
//                         pattern="[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}"
//                         title="Please enter a valid GST number."
//                         style={styles.input}
//                     />
//                 </label>
//                 <label style={styles.label}>
//                     Address:
//                     <input
//                         type="text"
//                         value={address}
//                         onChange={(e) => setAddress(e.target.value)}
//                         required
//                         style={styles.input}
//                     />
//                 </label>
//                 <label style={styles.label}>
//                     City:
//                     <input
//                         type="text"
//                         value={city}
//                         onChange={(e) => setCity(e.target.value)}
//                         required
//                         style={styles.input}
//                     />
//                 </label>
//                 <label style={styles.label}>
//                     State:
//                     <input
//                         type="text"
//                         value={state}
//                         onChange={(e) => setState(e.target.value)}
//                         required
//                         style={styles.input}
//                     />
//                 </label>
//                 <label style={styles.label}>
//                     Pincode:
//                     <input
//                         type="text"
//                         value={pincode}
//                         onChange={(e) => setPincode(e.target.value)}
//                         required
//                         style={styles.input}
//                     />
//                 </label>
//                 <label style={styles.label}>
//                     Password:
//                     <input
//                         type="password"
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                         required
//                         minLength={6}
//                         style={styles.input}
//                     />
//                 </label>
//                 <label style={styles.label}>
//                     Confirm Password:
//                     <input
//                         type="password"
//                         value={confirmPassword}
//                         onChange={(e) => setConfirmPassword(e.target.value)}
//                         required
//                         minLength={6}
//                         style={styles.input}
//                     />
//                 </label>

//                 {/* Terms and Conditions Checkbox */}
//                 <label style={styles.checkboxLabel}>
//                     <Checkbox
//                         checked={termsAccepted}
//                         onChange={(e) => setTermsAccepted(e.target.checked)}
//                         required
//                     />
//                     I agree to the{' '}
//                     <Link to="/terms-and-conditions" style={styles.link}>
//                         Terms and Conditions
//                     </Link>
//                 </label>

//                 <button type="submit" style={styles.button}>Sign Up</button>

//                 {error && <p style={styles.error}>{error}</p>}
//                 {success && <p style={styles.success}>{success}</p>}
//             </form>
//             <p style={styles.text}>
//                 Already have an account? <Link to='/' style={styles.link}>Login</Link>
//             </p>
//         </div>
//     );
// };



// const styles = {
//     container: {
//         maxWidth: '500px',
//         margin: '50px auto',
//         padding: '20px',
//         border: '1px solid #ccc',
//         borderRadius: '10px',
//         boxShadow: '0 0 10px rgba(0,0,0,0.1)',
//     },
//     heading: {
//         textAlign: 'center',
//         marginBottom: '20px',
//         color: '#000',
//     },
//     form: {
//         display: 'flex',
//         flexDirection: 'column',
//     },
//     label: {
//         marginBottom: '15px',
//         fontSize: '1em',
//     },
//     input: {
//         width: '100%',
//         padding: '10px',
//         marginTop: '5px',
//         borderRadius: '5px',
//         border: '1px solid #ccc',
//         fontSize: '1em',
//     },
//     button: {
//         padding: '10px',
//         borderRadius: '5px',
//         border: 'none',
//         backgroundColor: '#000',
//         color: 'white',
//         fontSize: '1em',
//         cursor: 'pointer',
//     },
//     error: {
//         color: 'red',
//         marginTop: '10px',
//         textAlign: 'center',
//     },
//     success: {
//         color: 'green',
//         marginTop: '10px',
//         textAlign: 'center',
//     },
//     text: {
//         textAlign: 'center',
//         marginTop: '10px',
//     },
//     link: {
//         color: '#000',
//         textDecoration: 'none',
//     },
//     checkboxLabel: {
//         fontSize: '1em',
//         marginBottom: '20px',
//     },
// };

// export default SignupPage;

import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { db, auth } from '../firebase.js'; // Ensure this path is correct
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';

 

const SignupPage = () => {
    const navigate = useNavigate();

    // State for form fields
    const [brandName, setBrandName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [gstNumber, setGstNumber] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [pincode, setPincode] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    // State for component logic
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [emailSent, setEmailSent] = useState(false);
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // Listen for email verification after signup
    useEffect(() => {
        let intervalId;
        
        const checkEmailVerification = async () => {
            const user = auth.currentUser;
            if (user && emailSent) {
                await user.reload(); // Refresh user data
                if (user.emailVerified) {
                    setSuccess('Email verified successfully! Redirecting to login...');
                    clearInterval(intervalId);
                    setTimeout(() => navigate('/'), 2000);
                }
            }
        };

        if (emailSent) {
            intervalId = setInterval(checkEmailVerification, 3000);
        }

        return () => clearInterval(intervalId);
    }, [navigate, emailSent]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }
        if (!termsAccepted) {
            setError('You must accept the terms and conditions to proceed.');
            return;
        }

        setIsLoading(true);

        try {
            const userCredential = await createUserWithEmailAndPassword(auth, emailAddress, password);
            const user = userCredential.user;
            await sendEmailVerification(user);
            setEmailSent(true);

            const userRef = doc(db, 'users', user.uid);
            await setDoc(userRef, {
                brandName,
                phoneNumber,
                emailAddress,
                gstNumber,
                address,
                city,
                state,
                pincode,
                uid: user.uid,
                profileUpdatedAt: serverTimestamp(),
            });

            setSuccess('Account created! Please check your email to verify your account.');

        } catch (err) {
            if (err.code === 'auth/email-already-in-use') {
                setError('Email already exists. Please try logging in.');
            } else if (err.code === 'auth/weak-password') {
                setError('Password is too weak. Please choose a stronger one.');
            } else if (err.code === 'auth/invalid-email') {
                setError('Please enter a valid email address.');
            } else {
                setError('An error occurred during sign up. Please try again.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleResendVerification = async () => {
        if (!auth.currentUser) {
            setError('No user found. Please sign up again.');
            return;
        }
        try {
            await sendEmailVerification(auth.currentUser);
            setSuccess('Verification email resent! Please check your inbox.');
        } catch (err) {
            setError('Failed to resend verification email. Please try again.');
        }
    };

    const inputStyles = "block w-full px-4 py-2 mt-1 text-gray-700 bg-white border border-gray-300 rounded-md focus:border-blue-500 focus:ring-blue-500 focus:ring-opacity-50 focus:outline-none";
    const labelStyles = "block text-sm font-medium text-gray-700";
    return (
        <div className="flex h-screen bg-white md:mx-24 mx-4">

<div className="hidden lg:flex lg:w-7/12 items-center justify-center h-screen overflow-hidden">
    <div className="w-full h-full flex justify-center items-center">
        <img 
            src="/illustration_unitee.png" 
            alt="" 
            className="object-contain max-w-full max-h-full"
        />
    </div>
</div>
            <div 
    className="w-full lg:w-5/12 overflow-y-auto" 
    style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        WebkitScrollbar: { display: 'none' }
    }}
>
                <div className="flex min-h-full w-full py-12">
                    {/* Max-width wrapper for the form/message content */}
                    <div className="w-full max-w-md md:pr-10 mx-2">
                        {emailSent ? (
                            <div className="text-center">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">Verify Your Email</h2>
                                <p className="text-gray-600 mb-4">
                                    We've sent a verification link to <strong className="text-gray-800">{emailAddress}</strong>.
                                </p>
                                <p className="text-gray-600 mb-6">
                                    Please click the link to complete your signup. Keep this page open; you'll be redirected automatically after verification.
                                </p>
                                <button 
                                    onClick={handleResendVerification}
                                    className="w-full px-4 py-2 mb-4 font-medium text-blue-600 bg-white border border-blue-600 rounded-md hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                >
                                    Resend Verification Email
                                </button>
                                {success && <p className="text-green-600 mt-4 text-sm">{success}</p>}
                                {error && <p className="text-red-600 mt-4 text-sm">{error}</p>}
                                <p className="mt-4 text-sm text-gray-600">
                                    Already verified?{' '}
                                    <Link to='/' className="font-bold text-black hover:underline">
                                        Go to Login
                                    </Link>
                                </p>
                            </div>
                        ) : (
                            <div>
                                <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6 text-left">Sign Up</h1>
                                {/* Reduced vertical spacing between form elements */}
                                <form onSubmit={handleSubmit} className="space-y-3">
                                    <div>
                                        <label htmlFor="brandName" className={labelStyles}>Brand Name</label>
                                        <input id="brandName" type="text" value={brandName} onChange={(e) => setBrandName(e.target.value)} required disabled={isLoading} className={inputStyles} />
                                    </div>
                                    <div>
                                        <label htmlFor="phoneNumber" className={labelStyles}>Phone Number</label>
                                        <input id="phoneNumber" type="tel" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} required pattern="[0-9]{10}" title="Please enter a valid 10-digit phone number." disabled={isLoading} className={inputStyles} />
                                    </div>
                                    <div>
                                        <label htmlFor="emailAddress" className={labelStyles}>Email Address</label>
                                        <input id="emailAddress" type="email" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} required disabled={isLoading} className={inputStyles} />
                                    </div>
                                    <div>
                                        <label htmlFor="gstNumber" className={labelStyles}>GST Number (Optional)</label>
                                        <input id="gstNumber" type="text" value={gstNumber} onChange={(e) => setGstNumber(e.target.value)} pattern="[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}" title="Please enter a valid GST number." disabled={isLoading} className={inputStyles} />
                                    </div>
                                    <div>
                                        <label htmlFor="address" className={labelStyles}>Billing Address</label>
                                        <input id="address" type="text" value={address} onChange={(e) => setAddress(e.target.value)} required disabled={isLoading} className={inputStyles} />
                                    </div>
                                    <div>
                                        <label htmlFor="city" className={labelStyles}>City</label>
                                        <input id="city" type="text" value={city} onChange={(e) => setCity(e.target.value)} required disabled={isLoading} className={inputStyles} />
                                    </div>
                                    <div>
                                        <label htmlFor="state" className={labelStyles}>State</label>
                                        <input id="state" type="text" value={state} onChange={(e) => setState(e.target.value)} required disabled={isLoading} className={inputStyles} />
                                    </div>
                                    <div>
                                        <label htmlFor="pincode" className={labelStyles}>Pincode</label>
                                        <input id="pincode" type="text" value={pincode} onChange={(e) => setPincode(e.target.value)} required pattern="[0-9]{6}" title="Please enter a valid 6-digit pincode." disabled={isLoading} className={inputStyles} />
                                    </div>
                                    <div>
                                        <label htmlFor="password" className={labelStyles}>Password</label>
                                        <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} disabled={isLoading} className={inputStyles} />
                                    </div>
                                    <div>
                                        <label htmlFor="confirmPassword" className={labelStyles}>Confirm Password</label>
                                        <input id="confirmPassword" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required minLength={6} disabled={isLoading} className={inputStyles} />
                                    </div>
                                    <div className="flex items-center pt-2">
                                        <input id="terms" name="terms" type="checkbox" checked={termsAccepted} onChange={(e) => setTermsAccepted(e.target.checked)} required disabled={isLoading} className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" />
                                        <label htmlFor="terms" className="ml-2 block text-sm text-gray-700">
                                            I agree to the{' '}
                                            <Link to="/terms-and-conditions" className="font-medium text-blue-600 hover:underline">
                                                Terms and Conditions
                                            </Link>
                                        </label>
                                    </div>

                                    <div className="pt-4">
                                        <button 
                                            type="submit"
                                            disabled={isLoading}
                                            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                                        >
                                            {isLoading ? 'Creating Account...' : 'Sign Up'}
                                        </button>
                                    </div>

                                    {error && <p className="text-red-600 mt-2 text-center text-sm">{error}</p>}
                                    {success && <p className="text-green-600 mt-2 text-center text-sm">{success}</p>}
                                </form>
                                <p className="mt-6 text-center text-sm text-gray-600">
                                    Already have an account?{' '}
                                    <Link to="/" className="font-bold text-black hover:underline">
                                        Login
                                    </Link>
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};



export default SignupPage;

// import React, { useState, useEffect } from 'react';
// import { useNavigate, Link } from 'react-router-dom';
// import { db, auth } from '../firebase.js';
// import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
// import { createUserWithEmailAndPassword, sendEmailVerification, onAuthStateChanged } from 'firebase/auth';
// import { Checkbox } from '@mui/material';

// const SignupPage = () => {
//     const navigate = useNavigate();

//     const [brandName, setBrandName] = useState('');
//     const [phoneNumber, setPhoneNumber] = useState('');
//     const [emailAddress, setEmailAddress] = useState('');
//     const [gstNumber, setGstNumber] = useState('');
//     const [address, setAddress] = useState('');
//     const [city, setCity] = useState('');
//     const [state, setState] = useState('');
//     const [pincode, setPincode] = useState('');

//     const [password, setPassword] = useState('');
//     const [confirmPassword, setConfirmPassword] = useState('');
//     const [error, setError] = useState('');
//     const [success, setSuccess] = useState('');
//     const [emailSent, setEmailSent] = useState(false);
//     const [termsAccepted, setTermsAccepted] = useState(false);
//     const [isLoading, setIsLoading] = useState(false);

//     // Listen for email verification
//     useEffect(() => {
//         const unsubscribe = onAuthStateChanged(auth, (user) => {
//             if (user && user.emailVerified && emailSent) {
//                 // User has verified their email, redirect to login
//                 setSuccess('Email verified successfully! Redirecting to login...');
//                 setTimeout(() => {
//                     navigate('/');
//                 }, 2000);
//             }
//         });

//         return () => unsubscribe();
//     }, [navigate, emailSent]);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setError('');
//         setSuccess('');
//         setEmailSent(false);
//         setIsLoading(true);

//         if (password !== confirmPassword) {
//             setError('Passwords do not match.');
//             setIsLoading(false);
//             return;
//         }

//         if (!termsAccepted) {
//             setError('You must accept the terms and conditions to proceed.');
//             setIsLoading(false);
//             return;
//         }

//         try {
//             // Create user account
//             const userCredential = await createUserWithEmailAndPassword(auth, emailAddress, password);
//             const user = userCredential.user;

//             // Send email verification
//             await sendEmailVerification(user);
//             setEmailSent(true);

//             // Save user profile data
//             const userRef = doc(db, 'users', user.uid);
//             await setDoc(userRef, {
//                 brandName,
//                 phoneNumber,
//                 emailAddress,
//                 gstNumber,
//                 address,
//                 city,
//                 state,
//                 pincode,
//                 uid: user.uid,
//                 emailVerified: false,
//                 profileUpdatedAt: serverTimestamp(),
//             });

//             setSuccess('Account created successfully! Please check your email and click the verification link to complete your signup.');

//         } catch (err) {
//             console.error('Error signing up:', err);
            
//             if (err.code === 'auth/email-already-in-use') {
//                 setError('Email already exists. Please try logging in or use a different email address.');
//             } else if (err.code === 'auth/weak-password') {
//                 setError('Password is too weak. Please choose a stronger password.');
//             } else if (err.code === 'auth/invalid-email') {
//                 setError('Please enter a valid email address.');
//             } else {
//                 setError('An error occurred. Please try again.');
//             }
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleResendVerification = async () => {
//         if (!auth.currentUser) {
//             setError('No user found. Please sign up again.');
//             return;
//         }

//         try {
//             await sendEmailVerification(auth.currentUser);
//             setSuccess('Verification email resent! Please check your inbox.');
//         } catch (err) {
//             console.error('Error resending verification email:', err);
//             setError('Failed to resend verification email. Please try again.');
//         }
//     };

//     return (
//         <div style={styles.container}>
//             <h1 style={styles.heading}>Sign up</h1>
            
//             {emailSent ? (
//                 <div style={styles.verificationContainer}>
//                     <h2 style={styles.verificationHeading}>Verify Your Email</h2>
//                     <p style={styles.verificationText}>
//                         We've sent a verification link to <strong>{emailAddress}</strong>
//                     </p>
//                     <p style={styles.verificationText}>
//                         Please check your email and click the verification link to complete your signup.
//                     </p>
//                     <p style={styles.verificationText}>
//                         Once verified, you'll be automatically redirected to the login page.
//                     </p>
//                     <button 
//                         onClick={handleResendVerification}
//                         style={styles.resendButton}
//                     >
//                         Resend Verification Email
//                     </button>
//                     <p style={styles.text}>
//                         Already verified? <Link to='/' style={styles.link}>Go to Login</Link>
//                     </p>
//                 </div>
//             ) : (
//                 <form onSubmit={handleSubmit} style={styles.form}>
//                     <label style={styles.label}>
//                         Brand Name:
//                         <input
//                             type="text"
//                             value={brandName}
//                             onChange={(e) => setBrandName(e.target.value)}
//                             required
//                             style={styles.input}
//                             disabled={isLoading}
//                         />
//                     </label>
//                     <label style={styles.label}>
//                         Phone Number:
//                         <input
//                             type="tel"
//                             value={phoneNumber}
//                             onChange={(e) => setPhoneNumber(e.target.value)}
//                             required
//                             pattern="[0-9]{10}"
//                             title="Please enter a valid 10-digit phone number."
//                             style={styles.input}
//                             disabled={isLoading}
//                         />
//                     </label>
//                     <label style={styles.label}>
//                         Email Address:
//                         <input
//                             type="email"
//                             value={emailAddress}
//                             onChange={(e) => setEmailAddress(e.target.value)}
//                             required
//                             style={styles.input}
//                             disabled={isLoading}
//                         />
//                     </label>
//                     <label style={styles.label}>
//                         GST Number (Optional):
//                         <input
//                             type="text"
//                             value={gstNumber}
//                             onChange={(e) => setGstNumber(e.target.value)}
//                             pattern="[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}"
//                             title="Please enter a valid GST number."
//                             style={styles.input}
//                             disabled={isLoading}
//                         />
//                     </label>
//                     <label style={styles.label}>
//                         Address:
//                         <input
//                             type="text"
//                             value={address}
//                             onChange={(e) => setAddress(e.target.value)}
//                             required
//                             style={styles.input}
//                             disabled={isLoading}
//                         />
//                     </label>
//                     <label style={styles.label}>
//                         City:
//                         <input
//                             type="text"
//                             value={city}
//                             onChange={(e) => setCity(e.target.value)}
//                             required
//                             style={styles.input}
//                             disabled={isLoading}
//                         />
//                     </label>
//                     <label style={styles.label}>
//                         State:
//                         <input
//                             type="text"
//                             value={state}
//                             onChange={(e) => setState(e.target.value)}
//                             required
//                             style={styles.input}
//                             disabled={isLoading}
//                         />
//                     </label>
//                     <label style={styles.label}>
//                         Pincode:
//                         <input
//                             type="text"
//                             value={pincode}
//                             onChange={(e) => setPincode(e.target.value)}
//                             required
//                             style={styles.input}
//                             disabled={isLoading}
//                         />
//                     </label>
//                     <label style={styles.label}>
//                         Password:
//                         <input
//                             type="password"
//                             value={password}
//                             onChange={(e) => setPassword(e.target.value)}
//                             required
//                             minLength={6}
//                             style={styles.input}
//                             disabled={isLoading}
//                         />
//                     </label>
//                     <label style={styles.label}>
//                         Confirm Password:
//                         <input
//                             type="password"
//                             value={confirmPassword}
//                             onChange={(e) => setConfirmPassword(e.target.value)}
//                             required
//                             minLength={6}
//                             style={styles.input}
//                             disabled={isLoading}
//                         />
//                     </label>

//                     {/* Terms and Conditions Checkbox */}
//                     <label style={styles.checkboxLabel}>
//                         <Checkbox
//                             checked={termsAccepted}
//                             onChange={(e) => setTermsAccepted(e.target.checked)}
//                             required
//                             disabled={isLoading}
//                         />
//                         I agree to the{' '}
//                         <Link to="/terms-and-conditions" style={styles.link}>
//                             Terms and Conditions
//                         </Link>
//                     </label>

//                     <button 
//                         type="submit" 
//                         style={{
//                             ...styles.button,
//                             opacity: isLoading ? 0.6 : 1,
//                             cursor: isLoading ? 'not-allowed' : 'pointer'
//                         }}
//                         disabled={isLoading}
//                     >
//                         {isLoading ? 'Creating Account...' : 'Sign Up'}
//                     </button>

//                     {error && <p style={styles.error}>{error}</p>}
//                     {success && <p style={styles.success}>{success}</p>}
//                 </form>
//             )}
            
//             {!emailSent && (
//                 <p style={styles.text}>
//                     Already have an account? <Link to='/' style={styles.link}>Login</Link>
//                 </p>
//             )}
//         </div>
//     );
// };

// const styles = {
//     container: {
//         maxWidth: '500px',
//         margin: '50px auto',
//         padding: '20px',
//         border: '1px solid #ccc',
//         borderRadius: '10px',
//         boxShadow: '0 0 10px rgba(0,0,0,0.1)',
//     },
//     heading: {
//         textAlign: 'center',
//         marginBottom: '20px',
//         color: '#000',
//     },
//     form: {
//         display: 'flex',
//         flexDirection: 'column',
//     },
//     label: {
//         marginBottom: '15px',
//         fontSize: '1em',
//     },
//     input: {
//         width: '100%',
//         padding: '10px',
//         marginTop: '5px',
//         borderRadius: '5px',
//         border: '1px solid #ccc',
//         fontSize: '1em',
//     },
//     button: {
//         padding: '10px',
//         borderRadius: '5px',
//         border: 'none',
//         backgroundColor: '#000',
//         color: 'white',
//         fontSize: '1em',
//         cursor: 'pointer',
//     },
//     resendButton: {
//         padding: '10px 20px',
//         borderRadius: '5px',
//         border: '1px solid #000',
//         backgroundColor: 'white',
//         color: '#000',
//         fontSize: '1em',
//         cursor: 'pointer',
//         marginBottom: '20px',
//     },
//     error: {
//         color: 'red',
//         marginTop: '10px',
//         textAlign: 'center',
//     },
//     success: {
//         color: 'green',
//         marginTop: '10px',
//         textAlign: 'center',
//     },
//     text: {
//         textAlign: 'center',
//         marginTop: '10px',
//     },
//     link: {
//         color: '#000',
//         textDecoration: 'none',
//     },
//     checkboxLabel: {
//         fontSize: '1em',
//         marginBottom: '20px',
//     },
//     verificationContainer: {
//         textAlign: 'center',
//         padding: '20px',
//     },
//     verificationHeading: {
//         color: '#000',
//         marginBottom: '20px',
//     },
//     verificationText: {
//         marginBottom: '15px',
//         lineHeight: '1.5',
//     },
// };

// export default SignupPage;